import { render, staticRenderFns } from "./twoo.vue?vue&type=template&id=ad58093c&scoped=true"
import script from "./twoo.vue?vue&type=script&lang=js"
export * from "./twoo.vue?vue&type=script&lang=js"
import style0 from "./twoo.vue?vue&type=style&index=0&id=ad58093c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad58093c",
  null
  
)

export default component.exports